import React from 'react'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { SavingAPI } from '@api'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { HeaderSection, FooterSection, LeafBox, Accordion } from '@components'

import qrwokee from '../../../assets/files/qr-wokee.png'

import './SavingsDetail.scss'
import { TitleComponent } from '../../../common/components/TitleComponent'
const Container = styled.div`
  background-color: #ffffff;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`

const Desktop = styled.div`
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
`

const Mobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    display: block;
  }
`

const setSize = (il, index) => {
  let size = il === 2 || il === 4 ? 6 : 4
  if (il > 4) {
    const mod = il % 3
    if (mod === 1 && index === il - 1) {
      size = 12
    } else if (mod === 2 && (index === il - 1 || index === il - 2)) {
      size = 6
    }
  }

  return size
}

const SavingsDetail = function () {
  const { t, i18n } = useTranslation()

  const { id } = useParams()
  const [data, setdata] = useState({})
  const [isLoading, setisLoading] = useState(false)

  const loadData = async function () {
    setisLoading(true)
    const reportData = await SavingAPI(`/${id}`)
    setdata(reportData.data.data)
    setisLoading(false)
  }

  useEffect(() => {
    loadData()
  }, [])

  const isOtherBenefit =
    typeof data.dataBlockManfaatTabungan != 'undefined' &&
    data.dataBlockManfaatTabungan.length > 0
      ? true
      : false
  const isDeposito =
    typeof data.title != 'undefined' &&
    data.title.toLowerCase().indexOf('deposito') === 0
      ? true
      : false

  return (
    <Container>
      <TitleComponent title={data.title} />
      {!isLoading && (
        <div className="saving-detail">
          <Desktop>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerDesktop}
              showButton={false}
            />
          </Desktop>

          <Mobile>
            <HeaderSection
              title={data.title}
              group={t('solusi_masa_depan_anda')}
              description={data.description}
              banner={data.imageBannerMobile}
              showButton={false}
            />
          </Mobile>

          <div className="p-0 m-0 container-fluid">
            <div className="mb-4 mb-lg-0 mx-0 px-lg-5 mx-lg-5 flex align-items-center position-relative row">
              {typeof data.title != 'undefined' &&
                data.title.indexOf('Tabungan Rencana') === 0 &&
                typeof data.dataBlockManfaatTabungan != 'undefined' &&
                data.dataBlockManfaatTabungan.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {i18n.t('solusi_tabungan_manfaat', {
                        tabungan: data.title,
                      })}
                    </h2>
                    <div className="row">
                      {data.dataBlockManfaatTabungan.map((item, index) => {
                        const size = setSize(
                          data.dataBlockManfaatTabungan.length,
                          index
                        )

                        return (
                          <LeafBox
                            key={index}
                            thin={true}
                            size={size}
                            title={item.titleManfaatTabungan}
                            description={item.descriptionManfaatTabungan}
                          />
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.dataBlockKeunggulanTabungan != 'undefined' &&
                data.dataBlockKeunggulanTabungan.length > 0 && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {t('solusi_tabungan_keunggulan', {
                        tabungan: data.title,
                      })}
                    </h2>
                    <div className="row">
                      {data.dataBlockKeunggulanTabungan.map((item, index) => {
                        const isThin =
                          item.descriptionKeunggulanTabungan === ''
                            ? true
                            : false
                        const size = setSize(
                          data.dataBlockKeunggulanTabungan.length,
                          index
                        )

                        return (
                          <LeafBox
                            key={index}
                            size={size}
                            thin={isThin}
                            number={index + 1}
                            title={item.titleKeunggulanTabungan}
                            description={item.descriptionKeunggulanTabungan}
                            // file={id === '2083' && index === 4 && qrwokee}
                          />
                        )
                      })}
                    </div>
                  </div>
                )}

              {typeof data.title != 'undefined' &&
                data.title.indexOf('Tabungan Rencana') === -1 &&
                isOtherBenefit && (
                  <div>
                    <h2 className="mt-5 mb-4 section-title">
                      {i18n.t('solusi_tabungan_keuntungan')}
                    </h2>
                    <div>{t('Fasilitas')}</div>
                    <br />
                    <div className="row">
                      {data.dataBlockManfaatTabungan.map((item, index) => {
                        return (
                          <LeafBox
                            key={index}
                            size={3}
                            number={index + 1}
                            title={item.titleManfaatTabungan}
                            description={item.descriptionManfaatTabungan}
                          />
                        )
                      })}
                    </div>
                    {data.disclaimer && (
                      <div>
                        <i>{data.disclaimer}</i>
                      </div>
                    )}
                  </div>
                )}

              {typeof data.dataBlockAccordion != 'undefined' &&
                data.dataBlockAccordion.length > 0 && (
                  <div className="mb-5">
                    <h2
                      className={
                        isDeposito && isOtherBenefit
                          ? ''
                          : 'mt-5 mb-4 section-title'
                      }
                    >
                      {t(
                        isDeposito
                          ? isOtherBenefit
                            ? ''
                            : 'solusi_tabungan_keuntungan'
                          : 'solusi_tabungan_detail'
                      )}
                    </h2>
                    <div className="row">
                      {data.dataBlockAccordion.map((item, index) => {
                        return (
                          <Accordion key={index} title={item.titleAccordion}>
                            {item.contentAccordion}
                          </Accordion>
                        )
                      })}
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      )}

      <FooterSection currentPage={t('simpanan')} />
    </Container>
  )
}

export default SavingsDetail
